import { Card, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export type SkeletonVariant = 'default' | 'compact';

interface AppointmentSkeletonProps {
  variant?: SkeletonVariant;
  count?: number;
}

function SingleAppointmentSkeleton({ variant = 'default' }: { variant?: SkeletonVariant }) {
  if (variant === 'compact') {
    return (
      <div className="p-3 border rounded-lg space-y-2">
        <div className="flex items-start justify-between">
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-5 w-16" />
        </div>
        <div className="flex gap-4">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-32" />
        </div>
        <Skeleton className="h-4 w-28" />
      </div>
    );
  }

  return (
    <Card>
      <CardHeader className="space-y-3">
        <div className="flex items-start justify-between">
          <div className="space-y-2">
            <Skeleton className="h-5 w-48" />
            <Skeleton className="h-5 w-20" />
          </div>
          <div className="flex gap-2">
            <Skeleton className="h-8 w-16" />
            <Skeleton className="h-8 w-16" />
          </div>
        </div>
        <div className="flex gap-4">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-4 w-24" />
        </div>
      </CardHeader>
    </Card>
  );
}

export function AppointmentSkeleton({ variant = 'default', count = 3 }: AppointmentSkeletonProps) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }, (_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: fixed-length placeholder list that never reorders
        <SingleAppointmentSkeleton key={`skeleton-${i}`} variant={variant} />
      ))}
    </div>
  );
}
